export enum ObjectFeaturesEnum {
    None = 0,
    ManualEntry = 1,
    MemoView = 2,
    AlarmView = 4,
    /*NotUsed = 8,*/
    Writedown = 16,
    /*NotUsed = 32,*/
    FormModify = 32,
    LiveData = 64,
    AlarmModify = 128,
    MemoModify = 256,
    TrendingView = 512,
    RunTickets = 1024,

    GasComposition = 2048,
    DeviceSpec = 4096,
    /*NotUsed = 8192*/
    HoursMinutesSeconds = 16384,
    FeetAndInches = 32768
};
